// import React, { useEffect, useRef } from "react";
// import { Html5Qrcode } from "html5-qrcode";

// // Inject global styles to kill the html5-qrcode default UI + animate scan line
// const style = document.createElement("style");
// style.textContent = `
//   #qr-reader-container video {
//     object-fit: cover !important;
//     width: 100% !important;
//     height: 100% !important;
//   }
//   #qr-reader-container img,
//   #qr-reader-container canvas {
//     display: none !important;
//   }
//   /* Kill ALL default html5-qrcode UI elements */
//   #qr-reader-container > *:not(video) {
//     display: none !important;
//   }
//   #qr-reader-container__scan_region,
//   #qr-reader-container__dashboard,
//   #qr-reader-container__status_span,
//   #qr-reader-container__header_message {
//     display: none !important;
//   }
//   [id^="qr-reader-container"] div,
//   [id^="qr-reader-container"] button,
//   [id^="qr-reader-container"] span,
//   [id^="qr-reader-container"] select,
//   [id^="qr-reader-container"] p {
//     display: none !important;
//   }

//   @keyframes scanMove {
//     0%   { top: 8%; opacity: 0.6; }
//     50%  { top: 88%; opacity: 1; }
//     100% { top: 8%; opacity: 0.6; }
//   }

//   .qr-scan-line {
//     position: absolute;
//     left: 10px;
//     right: 10px;
//     height: 3px;
//     border-radius: 20px;
//     background: linear-gradient(90deg, transparent, #00ff99, transparent);
//     box-shadow: 0 0 12px #00ff99, 0 0 24px #00ff99;
//     animation: scanMove 2s ease-in-out infinite;
//   }
// `;
// if (!document.head.querySelector("#qr-fix-styles")) {
//   style.id = "qr-fix-styles";
//   document.head.appendChild(style);
// }

// const QRScanner = ({ onScan, onClose }) => {
//   const scannerRef = useRef(null);
//   const isRunning = useRef(false);
//   const isMounted = useRef(true);

//   const stopScanner = async () => {
//     if (scannerRef.current && isRunning.current) {
//       isRunning.current = false;
//       try { await scannerRef.current.stop(); } catch (e) {}
//       try { scannerRef.current.clear(); } catch (e) {}
//     }
//   };

//   useEffect(() => {
//     isMounted.current = true;

//     const startScanner = async () => {
//       try {
//         const html5QrCode = new Html5Qrcode("qr-reader-container");
//         scannerRef.current = html5QrCode;

//         const cameras = await Html5Qrcode.getCameras();
//         if (!cameras?.length) return;

//         const backCamera =
//           cameras.find((c) => /back|rear|environment/i.test(c.label)) ||
//           cameras[cameras.length - 1];

//         await html5QrCode.start(
//           { deviceId: { exact: backCamera.id } },
//           {
//             fps: 10,
//             qrbox: (w, h) => {
//               const size = Math.floor(Math.min(w, h) * 0.7);
//               return { width: size, height: size };
//             },
//             aspectRatio: window.innerHeight / window.innerWidth,
//           },
//           (decodedText) => {
//             if (!isMounted.current) return;
//             isRunning.current = false;
//             stopScanner().then(() => onScan?.(decodedText));
//           },
//           () => {}
//         );

//         if (isMounted.current) {
//           isRunning.current = true;
//         } else {
//           await stopScanner();
//         }
//       } catch (err) {
//         console.error("Camera start error:", err);
//       }
//     };

//     const timer = setTimeout(startScanner, 300);
//     return () => {
//       isMounted.current = false;
//       clearTimeout(timer);
//       stopScanner();
//     };
//   }, []);

//   return (
//     <div style={{
//       position: "fixed", inset: 0, background: "#000",
//       zIndex: 9999, overflow: "hidden", width: "100%", height: "100dvh",
//     }}>
//       {/* Close Button */}
//       <button
//         onClick={async () => { await stopScanner(); onClose?.(); }}
//         style={{
//           position: "absolute",
//           top: "max(20px, env(safe-area-inset-top))",
//           right: 20, width: 48, height: 48,
//           borderRadius: "50%", border: "none",
//           background: "rgba(255,255,255,0.15)",
//           backdropFilter: "blur(12px)",
//           color: "#fff", fontSize: 22, cursor: "pointer", zIndex: 10001,
//         }}
//       >✕</button>

//       {/* Header */}
//       <div style={{
//         position: "absolute",
//         top: "max(60px, env(safe-area-inset-top))",
//         left: 0, right: 0, textAlign: "center", zIndex: 10000, padding: "0 20px",
//       }}>
//         <h2 style={{ color: "#fff", margin: 0, fontSize: "clamp(22px, 5vw, 30px)", fontWeight: 700 }}>
//           Scan QR Code
//         </h2>
//         <p style={{ color: "rgba(255,255,255,0.8)", marginTop: 10, fontSize: "clamp(13px, 3vw, 16px)" }}>
//           Place the QR code inside the frame
//         </p>
//       </div>

//       {/* Camera feed */}
//       <div style={{ width: "100%", height: "100%", position: "relative" }}>
//         <div id="qr-reader-container" style={{ width: "100%", height: "100%" }} />

//         {/* Custom overlay frame */}
//         <div style={{
//           position: "absolute", inset: 0,
//           display: "flex", alignItems: "center", justifyContent: "center",
//           pointerEvents: "none",
//         }}>
//           <div style={{
//             position: "relative",
//             width: "75vw", height: "75vw",
//             maxWidth: 300, maxHeight: 300,
//             minWidth: 220, minHeight: 220,
//           }}>
//             {/* Corner: Top Left */}
//             <div style={{ position: "absolute", top: 0, left: 0, width: 45, height: 45,
//               borderTop: "4px solid #00ff99", borderLeft: "4px solid #00ff99", borderRadius: "12px 0 0 0" }} />
//             {/* Corner: Top Right */}
//             <div style={{ position: "absolute", top: 0, right: 0, width: 45, height: 45,
//               borderTop: "4px solid #00ff99", borderRight: "4px solid #00ff99", borderRadius: "0 12px 0 0" }} />
//             {/* Corner: Bottom Left */}
//             <div style={{ position: "absolute", bottom: 0, left: 0, width: 45, height: 45,
//               borderBottom: "4px solid #00ff99", borderLeft: "4px solid #00ff99", borderRadius: "0 0 0 12px" }} />
//             {/* Corner: Bottom Right */}
//             <div style={{ position: "absolute", bottom: 0, right: 0, width: 45, height: 45,
//               borderBottom: "4px solid #00ff99", borderRight: "4px solid #00ff99", borderRadius: "0 0 12px 0" }} />

//             {/* Animated Scan Line */}
//             <div className="qr-scan-line" />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default QRScanner;


import React, { useEffect, useRef, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";

// Inject global styles to kill the html5-qrcode default UI + animate scan line
const style = document.createElement("style");
style.textContent = `
  #qr-reader-container video {
    object-fit: cover !important;
    width: 100% !important;
    height: 100% !important;
  }
  #qr-reader-container img,
  #qr-reader-container canvas {
    display: none !important;
  }
  #qr-reader-container > *:not(video) {
    display: none !important;
  }
  #qr-reader-container__scan_region,
  #qr-reader-container__dashboard,
  #qr-reader-container__status_span,
  #qr-reader-container__header_message {
    display: none !important;
  }
  [id^="qr-reader-container"] div,
  [id^="qr-reader-container"] button,
  [id^="qr-reader-container"] span,
  [id^="qr-reader-container"] select,
  [id^="qr-reader-container"] p {
    display: none !important;
  }

  @keyframes scanMove {
    0%   { top: 8%; opacity: 0.6; }
    50%  { top: 88%; opacity: 1; }
    100% { top: 8%; opacity: 0.6; }
  }

  .qr-scan-line {
    position: absolute;
    left: 10px;
    right: 10px;
    height: 3px;
    border-radius: 20px;
    background: linear-gradient(90deg, transparent, #00ff99, transparent);
    box-shadow: 0 0 12px #00ff99, 0 0 24px #00ff99;
    animation: scanMove 2s ease-in-out infinite;
  }

  @keyframes torchGlow {
    0%, 100% { box-shadow: 0 0 10px rgba(255,220,50,0.6); }
    50%       { box-shadow: 0 0 24px rgba(255,220,50,1); }
  }
`;
if (!document.head.querySelector("#qr-fix-styles")) {
  style.id = "qr-fix-styles";
  document.head.appendChild(style);
}

const QRScanner = ({ onScan, onClose }) => {
  const scannerRef = useRef(null);
  const isRunning  = useRef(false);
  const isMounted  = useRef(true);
  const videoTrack = useRef(null);

  const [torchSupported, setTorchSupported] = useState(false);
  const [torchOn, setTorchOn]               = useState(false);

  const stopScanner = async () => {
    if (scannerRef.current && isRunning.current) {
      isRunning.current = false;
      try { await scannerRef.current.stop(); } catch (e) {}
      try { scannerRef.current.clear(); } catch (e) {}
    }
  };

  // ── Toggle torch ────────────────────────────────────────────────────────────
  const toggleTorch = async () => {
    if (!videoTrack.current) return;
    const next = !torchOn;
    try {
      await videoTrack.current.applyConstraints({ advanced: [{ torch: next }] });
      setTorchOn(next);
    } catch (e) {
      console.warn("Torch toggle failed:", e);
    }
  };

  useEffect(() => {
    isMounted.current = true;

    const startScanner = async () => {
      try {
        const html5QrCode = new Html5Qrcode("qr-reader-container");
        scannerRef.current = html5QrCode;

        const cameras = await Html5Qrcode.getCameras();
        if (!cameras?.length) return;

        const backCamera =
          cameras.find((c) => /back|rear|environment/i.test(c.label)) ||
          cameras[cameras.length - 1];

        await html5QrCode.start(
          { deviceId: { exact: backCamera.id } },
          {
            fps: 10,
            qrbox: (w, h) => {
              const size = Math.floor(Math.min(w, h) * 0.7);
              return { width: size, height: size };
            },
            aspectRatio: window.innerHeight / window.innerWidth,
          },
          (decodedText) => {
            if (!isMounted.current) return;
            isRunning.current = false;
            stopScanner().then(() => onScan?.(decodedText));
          },
          () => {}
        );

        if (isMounted.current) {
          isRunning.current = true;

          // ── Grab video track for torch control ──
          try {
            const videoEl = document.querySelector("#qr-reader-container video");
            if (videoEl?.srcObject) {
              const track = videoEl.srcObject.getVideoTracks()[0];
              if (track) {
                videoTrack.current = track;
                const caps = track.getCapabilities?.() || {};
                if (caps.torch) setTorchSupported(true);
              }
            }
          } catch (e) {
            console.warn("Torch detection failed:", e);
          }

        } else {
          await stopScanner();
        }
      } catch (err) {
        console.error("Camera start error:", err);
      }
    };

    const timer = setTimeout(startScanner, 300);
    return () => {
      isMounted.current = false;
      clearTimeout(timer);
      stopScanner();
    };
  }, []);

  return (
    <div style={{
      position: "fixed", inset: 0, background: "#000",
      zIndex: 9999, overflow: "hidden", width: "100%", height: "100dvh",
    }}>

      {/* ── Flashlight Button (top-left, only if torch is supported) ── */}
      {torchSupported && (
        <button
          onClick={toggleTorch}
          style={{
            position: "absolute",
            top: "max(20px, env(safe-area-inset-top))",
            left: 20,
            width: 48, height: 48,
            borderRadius: "50%", border: "none",
            background: torchOn ? "rgba(255,220,50,0.92)" : "rgba(255,255,255,0.15)",
            backdropFilter: "blur(12px)",
            color: torchOn ? "#333" : "#fff",
            cursor: "pointer", zIndex: 10001,
            animation: torchOn ? "torchGlow 1.4s ease-in-out infinite" : "none",
            transition: "background 0.2s, color 0.2s",
            display: "flex", alignItems: "center",
            justifyContent: "center", flexDirection: "column", gap: 1,
          }}
          title={torchOn ? "Turn off flashlight" : "Turn on flashlight"}
        >
          <span style={{ fontSize: 20, lineHeight: 1 }}>🔦</span>
          <span style={{ fontSize: 9, fontWeight: 700, letterSpacing: 0.3 }}>
            {torchOn ? "ON" : "OFF"}
          </span>
        </button>
      )}

      {/* Close Button (top-right) */}
      <button
        onClick={async () => { await stopScanner(); onClose?.(); }}
        style={{
          position: "absolute",
          top: "max(20px, env(safe-area-inset-top))",
          right: 20, width: 48, height: 48,
          borderRadius: "50%", border: "none",
          background: "rgba(255,255,255,0.15)",
          backdropFilter: "blur(12px)",
          color: "#fff", fontSize: 22, cursor: "pointer", zIndex: 10001,
        }}
      >✕</button>

      {/* Header */}
      <div style={{
        position: "absolute",
        top: "max(60px, env(safe-area-inset-top))",
        left: 0, right: 0, textAlign: "center", zIndex: 10000, padding: "0 20px",
      }}>
        <h2 style={{ color: "#fff", margin: 0, fontSize: "clamp(22px, 5vw, 30px)", fontWeight: 700 }}>
          Scan QR Code
        </h2>
        <p style={{ color: "rgba(255,255,255,0.8)", marginTop: 10, fontSize: "clamp(13px, 3vw, 16px)" }}>
          Place the QR code inside the frame
        </p>
      </div>

      {/* Camera feed */}
      <div style={{ width: "100%", height: "100%", position: "relative" }}>
        <div id="qr-reader-container" style={{ width: "100%", height: "100%" }} />

        {/* Custom overlay frame */}
        <div style={{
          position: "absolute", inset: 0,
          display: "flex", alignItems: "center", justifyContent: "center",
          pointerEvents: "none",
        }}>
          <div style={{
            position: "relative",
            width: "75vw", height: "75vw",
            maxWidth: 300, maxHeight: 300,
            minWidth: 220, minHeight: 220,
          }}>
            {/* Corner: Top Left */}
            <div style={{ position: "absolute", top: 0, left: 0, width: 45, height: 45,
              borderTop: "4px solid #00ff99", borderLeft: "4px solid #00ff99", borderRadius: "12px 0 0 0" }} />
            {/* Corner: Top Right */}
            <div style={{ position: "absolute", top: 0, right: 0, width: 45, height: 45,
              borderTop: "4px solid #00ff99", borderRight: "4px solid #00ff99", borderRadius: "0 12px 0 0" }} />
            {/* Corner: Bottom Left */}
            <div style={{ position: "absolute", bottom: 0, left: 0, width: 45, height: 45,
              borderBottom: "4px solid #00ff99", borderLeft: "4px solid #00ff99", borderRadius: "0 0 0 12px" }} />
            {/* Corner: Bottom Right */}
            <div style={{ position: "absolute", bottom: 0, right: 0, width: 45, height: 45,
              borderBottom: "4px solid #00ff99", borderRight: "4px solid #00ff99", borderRadius: "0 0 12px 0" }} />

            {/* Animated Scan Line */}
            <div className="qr-scan-line" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default QRScanner;